import styled from "styled-components";

export const SlidesContainer = styled.div`
  width: 100%;
  height: 100vh;
`;